var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('add-or-update-sample-csv-form',{ref:"sampleCSVFileForm",on:{"create":_vm.onCreateNewSampleCSVFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }